export enum RegistrationStatus {
  PENDING = 'PENDING',
  VALIDATED_PAID = 'VALIDATED_PAID',
  VALIDATED_NOT_PAID = 'VALIDATED_NOT_PAID',
  REFUSED = 'REFUSED',
}
